export const userChallenge = {
  title: 'Bem-vindo à Antecipa.',
  subtitle: 'Informe seu e-mail.',
  submit: 'Entrar',
  register: 'Quero ser um cliente',
  inputs: {
    email: {
      label: 'E-mail',
    },
  },
  errors: {
    email: {
      invalid: 'E-mail está inválido',
      required: 'E-mail é obrigatório',
    },
  },
};
